import PND1ReportComponent from "features/Report/components/SalaryGroup/PND1Report";
import usePND1Report from "features/Report/hooks/salaryGroup/usePND1Report";

const PND1ReportPage = () => {
    const usePND1ReportProps = usePND1Report();
    return (<PND1ReportComponent {...usePND1ReportProps} />)
}

export default PND1ReportPage;